import styles from '../globals/pages.module.scss'
import { useEffect } from 'react'
import axios from 'axios'
import { useSearchParams } from 'react-router-dom'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { apiErrors } from '../helpers/apiErrors'

export default function Unsub() {
    let [searchParams] = useSearchParams()

    useEffect(() => {
        Loading.standard('Unsubscribing...')
        const email = searchParams.get('id')

        axios
            .post(`${process.env.REACT_APP_API_TOKEN_URL}/unsubscribe`, { email })
            .then((response) => {
                const responseData = response.data
                if (responseData === 'success') {
                    Report.success(
                        'Unsubscribed',
                        'You have been unsubscribed to the Sentinel Legal mailing list.',
                        'Okay',
                        () => {
                            // Don't redirect automatically, let user see the resubscribe option
                        }
                    )
                }
                Loading.remove()
            })
            .catch((e) => {
                console.error('error:', e)
                const serverError = e.response.data
                Loading.remove()
                apiErrors(serverError)
            })
    }, [searchParams])

    const handleResubscribe = () => {
        Loading.standard('Resubscribing...')
        const email = searchParams.get('client_id')

        axios
            .post(`${process.env.REACT_APP_API_TOKEN_URL}/remove-unsubscribe`, { email })
            .then((response) => {
                const responseData = response.data
                if (responseData === 'success') {
                    Report.success(
                        'Resubscribed',
                        'You have been resubscribed to the Sentinel Legal mailing list.',
                        'Okay',
                        () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        }
                    )
                }
                Loading.remove()
            })
            .catch((e) => {
                console.error('error:', e)
                const serverError = e.response?.data
                Loading.remove()
                apiErrors(serverError)
            })
    }

    return (
        <div
            className={`${styles.pageContent} ${styles.pocContent}`}
            style={{
                minHeight: 'calc(100vh - 200px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
            }}
        >
            <div
                className={styles.centeredContainer}
                style={{ padding: '60px 20px', textAlign: 'center', width: '100%' }}
            >
                <h1 className={styles.headerTitle} style={{ fontSize: '32px', marginBottom: '20px' }}>
                    Sorry to see you go
                </h1>
                <p style={{ fontSize: '16px', marginBottom: '40px', color: '#666' }}>
                    You've been removed from our email list.
                </p>
                <div style={{ marginTop: '40px' }}>
                    <p style={{ fontSize: '16px', marginBottom: '16px', color: '#666' }}>Did this by accident?</p>
                    <button
                        onClick={handleResubscribe}
                        style={{
                            padding: '10px 24px',
                            backgroundColor: '#C78E5F',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            fontFamily: 'Arial, Helvetica, sans-serif',
                            display: 'inline-block',
                            transition: 'background-color 0.2s ease',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#b07a4f'
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#C78E5F'
                        }}
                    >
                        Resubscribe
                    </button>
                </div>
            </div>
        </div>
    )
}
